const randomGenerator = (length = 12, buttonId = 'generatePassword', inputId = 'password') => {
    const input = document.querySelector(`#${inputId}`);
    const button = document.querySelector(`#${buttonId}`);

    if (!input || !button) {
        return;
    }

    function generate() {
        let password = '';
        const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

        for (let i = 0, n = charset.length; i < length; i++) {
            password += charset.charAt(Math.floor(Math.random() * n));
        }

        return password;
    }

    button.addEventListener('click', () => {
        input.value = generate();
    });
};

export default randomGenerator;
